import * as React from 'react'
import * as PropTypes from 'prop-types'
import Input from '@material-ui/core/Input'
import { withStyles } from '@material-ui/core/styles'
import { DataTypeProvider } from '@devexpress/dx-react-grid'
import { validate as isCNPJ, format as formatCNPJ } from 'cnpj'
import { isValid as isCPF, format as formatCPF } from 'cpf'

const styles = {
  input: {
    textAlign: 'left',
    width: '100%'
  }
}

const getInputValue = value => {
  if (!value) return ''
  if (isCPF(value)) return formatCPF(value)
  if (isCNPJ(value)) return formatCNPJ(value)
  return value
}

const Formatter = ({ value }) => getInputValue(value)

const EditorBase = ({ value, onValueChange, classes }) => {
  const handleChange = event => {
    const { value: targetValue } = event.target
    if (targetValue === '') {
      onValueChange()
      return
    }
    onValueChange(getInputValue(targetValue))
  }
  return (
    <Input
      classes={{
        input: classes.input
      }}
      fullWidth
      value={getInputValue(value)}
      onChange={handleChange}
    />
  )
}

EditorBase.propTypes = {
  value: PropTypes.string,
  onValueChange: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired
}

EditorBase.defaultProps = {
  value: undefined
}

const Editor = withStyles(styles)(EditorBase)

const availableFilterOperations = [
  'equal',
  'notEqual',
  'greaterThan',
  'greaterThanOrEqual',
  'lessThan',
  'lessThanOrEqual'
]

const CodeTypeProvider = props => (
  <DataTypeProvider
    formatterComponent={Formatter}
    editorComponent={Editor}
    availableFilterOperations={availableFilterOperations}
    {...props}
  />
)

export default CodeTypeProvider
